// @flow
import { LARGE_VIEWPORT, MEDIUM_VIEWPORT, SMALL_VIEWPORT } from '@alphaott/app-config'
import { rgba } from 'polished'

import { colorPalette } from '../colorPalettes'
import type { ColorType } from '../colorPalettes'

export const itplayColors: ColorType = {
  ...colorPalette,
  grayText: '#B0B0B0',
  grayLabel: '#717171',
  grayBorder: 'rgba(255, 255, 255, 0.38)',
  primary: '#F60030',
  secondary: '#F60030',
}

export const darkTheme = {
  colors: itplayColors,
  background: {
    primary: '#181818',
    secondary: '#262626',
    highlight: itplayColors.dark,
    select: '#2e2e2e',
    footerTop: '#333',
  },
  text: {
    primary: itplayColors.primaryGray,
    secondary: itplayColors.secondaryGray,
    disabled: itplayColors.grayText,
    link: itplayColors.secondaryGray,
    hint: itplayColors.white,
    highlight: itplayColors.secondary,
    gray: itplayColors.primaryGray,
    seeAll: itplayColors.secondaryGray,
    primaryContrast: '#ffffff',
  },
  border: {
    primary: itplayColors.primaryGray,
    gray: itplayColors.secondaryGray,
  },
  filter: {
    primary: itplayColors.primaryGray,
    secondary: itplayColors.secondaryGray,
    disabled: itplayColors.secondaryGray,
    highlight: '#111111',
  },
  tabs: {
    bg: '#181818',
    containerBg: itplayColors.dark,
    color: itplayColors.white,
    border: itplayColors.primary,
    scrollbarThumb: '#bdbdbd',
    programTitle: itplayColors.white,
  },
  programGuide: {
    programBox: {
      background: {
        main: '#2e2e2e',
        hover: itplayColors.dark,
        selected: itplayColors.dark,
        progress: rgba(itplayColors.primary, 0.3),
        past: rgba(itplayColors.primary, 0.3),
        pastSelected: itplayColors.dark,
        pastHover: itplayColors.dark,
        empty: '#555555',
        emptyProgress: rgba(itplayColors.primary, 0.1),
      },
      text: {
        empty: itplayColors.secondaryGray,
      },
    },
    programGuidePictureOverlay: {
      horizontal:
        // eslint-disable-next-line max-len
        `linear-gradient(90deg, #181818 0%,${rgba('#181818', 0.97)} 13.03%,${rgba('#181818', 0.69)} 43.24%,${rgba(
          '#181818',
          0,
        )} 100%);`,
      vertical: `linear-gradient(0, #181818 0%,${rgba('#181818', 0.73)} 34.97%,${rgba('#181818', 0)} 100%);`,
    },
  },
  card: {
    title: itplayColors.white,
    subTitle: itplayColors.secondaryGray,
    bg: itplayColors.grayText,
    number: '#DFDFDF',
    boxShadow: '#2e2e2e',
    loaderBackgroundImage: 'linear-gradient(to right, #222 0%, #111 20%, #222 40%, #222 100%)',
  },
  dimension: {
    signLogoSize: 160,
  },
  size: 'default',
  breakpoints: [`${SMALL_VIEWPORT}px`, `${MEDIUM_VIEWPORT}px`, `${LARGE_VIEWPORT}px`],
  signIn: {
    clipPath: false,
  },
}
